const routes = [
  {
    name: 'photos-wechat',
    path: '/photos-wechat/',
    component: () => import('../../pages/photos-wechat/index'),
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../../pages/photos-wechat/login'),
      },
      {
        name: 'photosWechatForm',
        path: 'form',
        component: () => import('../../pages/photos-wechat/form'),
      },
      {
        name: 'photosWechatDetail',
        path: 'detail',
        component: () => import('../../pages/photos-wechat/detail'),
      },
      {
        name: 'photosWechatQrcode',
        path: 'qrcode',
        component: () => import('../../pages/photos-wechat/qrcode'),
      },
    ],
  },

];

export default routes;
